var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row tabs"},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,staticClass:"tab",class:{'active': index === _vm.activeIndex},on:{"click":function($event){return _vm.onTabClick(item, index)}}},[_vm._v(_vm._s(item)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }